import { render, staticRenderFns } from "./GocardlessSuccessful.vue?vue&type=template&id=6901e27d&"
import script from "./GocardlessSuccessful.vue?vue&type=script&lang=ts&"
export * from "./GocardlessSuccessful.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports